import React, { PureComponent } from 'react';
import { string, node, func } from 'prop-types';
import mediaQueries from 'utils/mediaQueries';

export default class Sticky extends PureComponent {
    static propTypes = {
        className: string,
        children: node.isRequired,
        smartSticky: func.isRequired,
    };

    static defaultProps = {
        className: '',
    };

    constructor(props) {
        super(props);
        this.filterSmartSticky = null;
    }

    getStickyRef = element => {
        if (!this.props.smartSticky) return null;

        if (this.filterSmartSticky) {
            this.filterSmartSticky.destroy();
        }

        if (element) {
            this.filterSmartSticky = this.props.smartSticky([element], {
                cssClass: 'sticky-fixed',
                smart: true,
                screenSize: { min: 0, max: mediaQueries.screenXsMax },
            });

            return this.filterSmartSticky;
        }

        return null;
    };

    render() {
        const { className, children } = this.props;
        return (
            <div className={className} ref={this.getStickyRef}>
                {children}
            </div>
        );
    }
}
